import { createFileRoute } from '@tanstack/react-router'
import { TwoFactorChallengeForm } from '@/features/auth/two-factor-challenge'

/**
 * Route shell. Definition and guards only — the form lives in a feature.
 */
export const Route = createFileRoute('/two-factor')({
  component: TwoFactorChallengeForm,
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
})
